import { discountRuleSchema } from "@redotech/redo-conversion-core-common/discount-rules/discount-rule";
import * as z from "zod";

export const getDiscountRules = {
  name: "getDiscountRules" as const,
  input: z.null(),
  output: z.object({
    rules: z.array(discountRuleSchema),
    isUsingDiscountRules: z.boolean(),
    canUseDiscountRules: z.object({
      canUse: z.boolean(),
      reasons: z.array(z.string()),
    }),
  }),
};
